import { Navigate, useLocation } from 'react-router-dom';
import Loader from './Loader.jsx';
import { useAuth } from '../context/AuthContext.jsx';

// Like PrivateRoute but additionally requires role='admin'. Non-admins get
// bounced back to / with a flash; unauthenticated users hit the normal
// /login redirect first.
export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Loader label="Loading…" />;
  }
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnUrl=${next}`} replace />;
  }
  if (user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }
  return children;
}
